import React from 'react';

const FlagTr = props => (
  <svg viewBox="0 0 1200 800" {...props}>
    <path fill="#E30A17" d="M0 0h1200v800H0z" />
    <circle cx={425} cy={400} r={200} fill="#fff" />
    <circle cx={475} cy={400} r={160} fill="#e30a17" />
    <path fill="#fff" d="M583.334 400l180.901 58.779-111.804-153.885v190.212l111.804-153.885z" />
  </svg>
);

export default FlagTr;
